<template lang="html">
  <v-dialog 
    v-model="dialog" 
    max-width="1300"
    persistent
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="User Configuration"
      text="Edit incomplete profile"
      class="mb-0"
    >
      <v-container
        v-if="loading"
        style="height: 150px;"
      >
        <v-row
          class="fill-height"
          align="center" 
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-row>     
      </v-container>
      <v-container v-else>
        <v-stepper v-model="step">
          <v-stepper-header>
            <template v-for="(stepperHeader,i) in stepperHeaders">
              <v-stepper-step
                :key="`${i}-key`"
                :step="i+1"
                :complete="i+1 < step"
              >
                {{ stepperHeader.name }}
              </v-stepper-step>
              <v-divider
                v-if="i !== stepperHeaders"
                :key="i"
              />
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <employee-form-edit
                ref="employeeFormDetail"
                :employee="employee"
                @close-dialog="closeDialog"
                @next-step="nextStep"
                @save-as-draft="saveAsDraft"
              />
            </v-stepper-content>

            <v-stepper-content step="2">
              <employee-report-to-form-edit
                ref="reportToFormDetail"
                :step="step"
                :employee="employee"
                @close-dialog="closeDialog"
                @previous-step="previousStep"
                @next-step="nextStep"
                @save-as-draft="saveAsDraft"
              />
            </v-stepper-content>

            <v-stepper-content step="3">
              <user-form-edit
                ref="userFormDetail"
                :employee="employee"
                @close-dialog="closeDialog"
                @previous-step="previousStep"
                @save-as-draft="saveAsDraft"
                @submit-form="submitForm"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {  
    components: {
      UserFormEdit: () => import('@/components/user/FormEdit'),
      EmployeeFormEdit: () => import('@/components/employee/FormEdit'),
      EmployeeReportToFormEdit: () => import('@/components/employee/report-to/FormEdit'),
    },    
    data () {
      return {
        step: 1,
        stepperHeaders: [
          { 'name': 'Employee' },
          { 'name': 'Employee Report To' },
          { 'name': 'User' },
        ],
        dialog: false,
        loading: false,
        employee: null,
      }
    },
    watch: {
      dialog: function (val) {
        if (!val) return this.$resetData()

        this.step = 1
      },
    },
    methods: {
      toggleDialog (employee) {
        this.dialog = true

        this.$api.hrisEmployees().show(employee.employee_uid + '?status=draft')
          .then(res => {
            this.employee = res.data
            this.loading = false
          })
      },
      closeDialog () {
        this.$refs.employeeFormDetail.resetData()
        this.$refs.reportToFormDetail.resetData()
        this.$refs.userFormDetail.resetData()

        this.dialog = false
      },
      nextStep () {
        this.step += 1
      },
      previousStep () {
        this.step -= 1
      },
      submitForm () {
        this.$refs.employeeFormDetail.$validator.validateAll().then((result) => {
          if (!result) {
            this.step = 1
          } else {
            this.$refs.userFormDetail.loadingTrue()
            this.$api.employees().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$snack({ message: 'Employee created successfully' })
                  this.showEmployeeOverview(res.data.employee.employee_uid)
                }
                this.$emit('reloadEmployeeList')
                this.closeDialog()
              })
              .catch((err) => {
                this.handleErrors(err)
              })
              .then(() => {
                this.$refs.userFormDetail.loadingFalse()
              })
          }
        })
      },
      saveAsDraft () {
        this.$api.employees().saveAsDraft(this.prepareFormData())
          .then(() => {
            this.$snack({ message: 'Employee saved to draft' })

            this.$emit('reloadEmployeeList')
            this.closeDialog()    
          })
          .catch((err) => {
            this.handleErrors(err)
          })
          .then(() => {
            this.$refs.reportToFormDetail.draftProgressing = false
            this.$refs.userFormDetail.draftProgressing = false
            this.$refs.employeeFormDetail.draftProgressing = false
          })
      },
      showEmployeeOverview (employeeUid) {
        this.$api.employees().showOverview(employeeUid)
          .then(response => {
            this.$emit('openProfile', response.data)
          })
      },
      handleErrors (err) {
        if (err.response.status === 422) {
          if (err.response.data.errors) {
            let errors = err.response.data.errors
            for (const param in errors) {
              this.$snack({ 
                color: 'error',
                message: `${errors[param]}`, 
              })
            }
          } else {
            this.$snack({
              color: 'error',
              message: err.response.data.message,
            })
          }
        } else {
          this.$snack({
            color: 'error',
            message: 'Unable to create employee',
          })
        }
      },
      prepareFormData () {
        let employeeFormData = this.$refs.employeeFormDetail.employeeFormData()
        let reportToFormData = this.$refs.reportToFormDetail.getFormData()
        let userFormData = this.$refs.userFormDetail.getFormData()

        return {
          employeeData: employeeFormData,
          reportToData: reportToFormData,
          userData: userFormData,
        }
      },
    },
  }
</script>
